import { requestEntrepelung } from "./entrepelung.services"

export const requestDeclauter = async (data) => {
    try {
        const response = await requestEntrepelung(data);
        const resp = await response.json();
        //console.log(resp);
        return resp;
    } catch (error) {
        console.log({error});
    }
}